module.exports = __webpack_public_path__ + "img/ua.841d259d.svg";